<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/umSSGF/images/Brownsville-cover.jpg?1733067604842" alt="This image is the cover for the book Brownsville"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brownsville
      </h1>
      <p class="bookDescription body article font2">
        <b>"Terrific stories...Just about perfect" (<i>Entertainment Weekly</i>): <i>Brownsville </i>is the collection that established Oscar Casares as one of the leading voices in the literature of the modern Southwest.</b><br/> At the country's edge, on the Mexican border, Brownsville, Texas, is a town like many others. It is a place where people work hard to create better lives for their children, where people bear grudges against their neighbors, where love blossoms only to fade, and where the only real certainty is that life holds surprises. <br/>In his sparkling debut, Oscar Casares creates a cast of unforgettable characters confronting everyday possibilities and contradictions: Diego, an eleven-year-old whose job at a fireworks stand teaches him a lesson in defiance; Bony, a young man whose discovery of a monkey's head on his lawn drives a wedge between him and his parents; Lola, whose stolen bowling ball offers an unlikely chance for change. The achievement of <i>Brownsville </i>lies in its remarkably honest portrayal of these lives -- the lives of people whose dreams and yearnings and regrets are at once unique and universal. <br/><b>"Marvelous...<i>Brownsville </i>resembles early Steinbeck work more than anything else." --Carolyn See, <i>Washington Post</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Oscar Casares
      </h2>
      
      <p class="authorDescription body article">Oscar Casares gave up a successful career in advertising to pursue his dream of becoming a writer. He received an MFA at Iowa and his stories have appeared in the <I>Iowa Review</I>, <I>Colorado Review</I>, <I>Northwest Review</I>, and <I>Threepenny Review</I>. He is the author of the short story collection <I>Brownsville</I> and lives in San Antonio, Texas, with his wife.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ac121fe